<template>
  <div class="container">
    <div class="head">
      <div class="title">
        <div class="text">游客投诉处置满意度</div>
        <div class="head_right_complain">

          <div class="branch" v-if="Number(deduction)">-{{ Number(deduction)/100 }}</div>
          <div class="num">{{ score }}/{{ totalScore }}</div>
        </div>
      </div>
      <div class="tip">
        <!-- <div class="con">{{areaName}}</div> -->
        <!-- <div class="con">{{areaType == '1' ? '一' : '二'}}类地区</div> -->
      </div>
      <div class="date">{{ areaName }} {{ quarterName }}</div>
    </div>
    <div class="pg-pd12">
      <!-- <causeDeduction :causeContent="causeContent" causeTitle="扣分原因" /> -->

      <div class="main">
        <div class="title">游客满意度情况</div>
        <div class="content">
          <div class="flex flex-col pt-24 items-center">
            <div class="text-12 font-400 text-[#333333] flex flex-row gap-4">
              <span>满意度得分</span>
              <van-popover v-model="showPopover" trigger="click" theme="dark">
                <div class="text-14 px-8 py-12 max-w-240 text-[#e4e3e3]">得分=（非常满意件数×10+满意件数x6+不满意件数×1）/投诉件总数</div>
                <template #reference>
                  <img src="@/assets/appraise/ic_appraise_help.png" class="size-12 object-scale-down" />
                </template>
              </van-popover>
            </div>
            <div class="text-32 font-bold text-[#36B374] mt-6">{{ score }}</div>
          </div>
          <div class="tongji">
            <div class="tj-item">
              <div class="name">非常满意</div>
              <div class="num">
                {{ satisfyingNum }}
                <span>件</span>
              </div>
            </div>
            <div class="tj-item">
              <div class="name">基本满意</div>
              <div class="num">
                {{ satisfiedNum }}
                <span>件</span>
              </div>
            </div>
            <div class="tj-item">
              <div class="name">不满意</div>
              <div class="num">
                {{ ilsatisfyNum }}
                <span>件</span>
              </div>
            </div>


          </div>
          <!-- <div class="ts-list" @click="goCompalinList">
            <span>查看投诉件列表</span>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import causeDeduction from "../../components/causeDeduction"; // 扣分原因
import api from "../../../../service/modules/appraiseNew";
import Vue from 'vue';
import { Popover } from 'vant';

Vue.use(Popover);

export default {
  components: {
    causeDeduction,
  },

  data() {
    return {
      causeContent: "",
      complainNum: "",
      deduction: "",
      satisfiedNum: "",
      satisfyingNum: "",
      ilsatisfyNum: '',
      areaType: "",
      cityId: "",
      totalScore: this.$route.query.totalScore,
      score: this.$route.query.score,
      year: this.$route.query.year,
      quarter: this.$route.query.quarter,
      quarterName: this.$route.query.quarterName,
      area: this.$route.query.area,
      areaName: this.$route.query.areaName,
      showPopover:  false,
    };
  },
  methods: {
    // 详情
    async queryDetail() {
      const { year, quarter, area } = this.$route.query;
      let params = {
        year,
        quarter,
        area,
      };
      // let res = await api.complainDoneRate(params);
      let res = await api.findAllComplainDoneSatisfy(params);
      let result = {}
      if (res.ret == 0 && res.data && res.data.all && res.data.all.length > 0) {
        result = res.data.all.find(item => item.area == this.area) ?? []
      }else if (res.ret == 0 && res.data && res.data.oneAreaTypeResVO && res.data.oneAreaTypeResVO.length > 0) {
        result = res.data.oneAreaTypeResVO.find(item => item.area == this.area) ?? []
      }else if (res.ret == 0 && res.data && res.data.twoAreaTypeResVO && res.data.twoAreaTypeResVO.length > 0) {
        result = res.data.twoAreaTypeResVO.find(item => item.area == this.area) ?? []
      }

      const {
          deductionReason,
          complainNum,
          deduction,
          areaName,
          areaType,
          quarterCN,
          satisfiedNum,
          satisfyingNum,
          ilsatisfyNum,
          cityId,
        } = result;
        this.causeContent = deductionReason;
        this.complainNum = complainNum;
        this.deduction = deduction;
        this.satisfiedNum = satisfiedNum;
        this.satisfyingNum = satisfyingNum;
        this.ilsatisfyNum = ilsatisfyNum;
        this.areaName = areaName;
        this.areaType = areaType;
        this.cityId = cityId;
    },
    goCompalinList() {
      const { year, quarter, areaName } = this.$route.query;
      // this.$router.push(`/appraise/complainLists?cityId=${this.cityId}&year=${year}&quarter=${quarter}`);

      this.$router.push(
        `/complaint/checkList?type=satisfiedList&areaOne=${this.cityId}&fullAdress=${areaName}&year=${year}&quarter=${quarter}`
      );
    },
  },

  mounted() { },

  created() {
    this.queryDetail();
  },
};
</script>
<style scoped lang="less">
.container {
  min-height: 100vh;
  background: rgba(251, 251, 251, 1);
  padding-bottom: 24px;

  .pg-pd12 {
    padding-left: 12px;
    padding-right: 12px;
  }

  .head {
    width: 100%;
    background: #fff;
    padding: 24px 12px;
    margin-bottom: 24px;

    .title {
      height: 22px;
      line-height: 22px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .head_right_complain {
        text-align: right;
        margin-top: 22px;
      }

      .text {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 20px;
      }

      .num {
        font-size: 14px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        color: rgba(153, 153, 153, 1);
        line-height: 22px;
        margin-top: 2px;
      }

      .branch {
        height: 22px;
        font-size: 22px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        color: rgba(255, 77, 77, 1);
        line-height: 22px;
      }
    }

    .tip {
      margin-top: 12px;
      display: flex;
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(54, 179, 116, 1);

      .con {
        border: 1px solid rgba(54, 179, 116, 1);
        padding: 2px 4px;
        margin-right: 14px;
      }
    }

    .date {
      margin-top: 12px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 12px;
    }
  }

  .main {
    margin: 24px 0 30px 0;

    .title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }

    .content {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
      border-radius: 3px;
      margin-top: 12px;

      .tongji {
        display: flex;
        align-items: center;
        border-top: solid 1px #eeeeee;
        border-bottom: solid 1px #eeeeee;
        margin-top: 24px;

        .tj-item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          flex: 1;
          height: 72px;
          text-align: center;
          border-right: solid 1px #eeeeee;

          .name {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }

          .num {
            font-size: 20px;
            font-family: DIN-Bold, DIN;
            font-weight: bold;
            color: rgba(54, 179, 116, 1);
            margin-top: 8px;

            span {
              font-size: 10px;
              padding-left: 4px;
            }
          }
        }

        .tj-item:last-child {
          border-right: 0;
        }
      }

      .ts-list {
        padding: 12px 0;
        text-align: center;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(155, 155, 155, 1);
        line-height: 17px;

        span {
          padding-right: 10px;
          background: url("../../../../assets/image/t-right.png") no-repeat;
          background-size: 8px 8px;
          background-position: right center;
        }
      }
    }
  }

  .complain {
    position: relative;
    line-height: 46px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    padding: 0 16px;
    margin-top: 24px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
  }

  .complain::after {
    content: "";
    position: absolute;
    right: 16px;
    top: 16px;
    width: 12px;
    height: 12px;
    background: url("../../../../assets/image/t-right.png") no-repeat;
    background-size: 12px 12px;
  }
}
</style>
